import { h, svgUse } from '../../../utils/dom.js';
import { t } from '../../../i18n/index.js';

export function StreakBanner() {
  return h('div', { class: 'streak-banner' },
    svgUse('ic-flame'),
    h('div', { class: 'line1' }, t('streakLabel')),
    h('div', { class: 'line2' }, t('streakVal')),
    h('div', { class: 'line3' }, t('streakSub')),
  );
}
